import axios from "axios";

const DYNATRACE_API_URL = "https://iec67099.live.dynatrace.com/api/v1/rum/jsTagSri";

/**
 * Fetches the Dynatrace HTML snippet using the configured application ID.
 * @returns The HTML snippet as a string.
 */
export async function fetchDynatraceSnippet(): Promise<string> {
  const DYNATRACE_API_TOKEN = process.env.DYNATRACE_API_TOKEN;
  const DYNATRACE_APPLICATION_ID = process.env.NEXT_PUBLIC_DYNATRACE_APPLICATION_ID;
  if (!DYNATRACE_API_TOKEN) {
    throw new Error("DYNATRACE_API_TOKEN is not set in environment variables");
  }

  if (!DYNATRACE_APPLICATION_ID) {
    throw new Error("NEXT_PUBLIC_DYNATRACE_APPLICATION_ID is not set in environment variables");
  }

  const url = `${DYNATRACE_API_URL}/${DYNATRACE_APPLICATION_ID}`;
  const response = await axios.get(url, {
    headers: {
      Authorization: `Api-Token ${DYNATRACE_API_TOKEN}`,
      Accept: "text/plain",
    },
  });
  return response.data;
}
